export default function About() {
      return (
        <div>
            <h2 className="about-page-header">About Us</h2>
            <p className="about-page-content">We are dreamers under the stars, building experiences with React and imagination.</p>
        </div>
        
  );  
}

